import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import { Lightbox } from 'yet-another-react-lightbox';
// eslint-disable-next-line
import 'yet-another-react-lightbox/styles.css';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { MdOutlineEdit } from 'react-icons/md';
import { CiTrash } from 'react-icons/ci';
import { DatePicker } from '@mui/x-date-pickers';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  CircularProgress,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormLabel,
} from '@mui/material';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
// components
import Swal from 'sweetalert2';
import { CSVLink } from 'react-csv';
import { FileText } from 'lucide-react';
import Scrollbar from '../components/scrollbar';

import Iconify from '../components/iconify';
import { AppWidgetSummary } from '../sections/@dashboard/app';

import {
  deleteUploads,
  updateMaintance,
  getUsers,
  getAllCleaningReport,
  deleteCleanerReport,
  getAllCleaner,
  getBnbList,
  checkInCheckOutCount,
  getCleanerSetting,
  updateCleaningReport,
} from '../helper/backend_helper';
import appConfig from '../config';
import { SolutionListHead, SolutionListToolbar } from '../components/addSolution';
import InfoTooltip from '../components/InfoTooltip';

const styles = `
  <style>
    .yarl__button {
      margin-top: 30px;
    }
  </style>
`;
// ----------------------------------------------------------------------
// const users = [
//   {
//     pic: 'http://localhost:3000/assets/images/avatars/avatar_default.jpg',
//     title: 'Lorem Ipsum dolor sit',
//   },
//   {
//     pic: 'http://localhost:3000/assets/images/avatars/avatar_default.jpg',
//     title: 'Lorem Ipsum dolor sit',
//   },
//   {
//     pic: 'http://localhost:3000/assets/images/avatars/avatar_default.jpg',
//     title: 'Lorem Ipsum dolor sit',
//   },
//   {
//     pic: 'http://localhost:3000/assets/images/avatars/avatar_default.jpg',
//     title: 'Lorem Ipsum dolor sit',
//   },
//   {
//     pic: 'http://localhost:3000/assets/images/avatars/avatar_default.jpg',
//     title: 'Lorem Ipsum dolor sit',
//   },
//   {
//     pic: 'http://localhost:3000/assets/images/avatars/avatar_default.jpg',
//     title: 'Lorem Ipsum dolor sit',
//   },

// ];

const TABLE_HEAD = [
  { id: '', label: 'BnB', alignRight: true },
  { id: '', label: 'Cleaner Name', alignRight: true },
  { id: '', label: 'Guest Name', alignRight: true },
  { id: '', label: 'Date', alignRight: true },
  { id: '', label: 'Start Time', alignRight: true },
  { id: '', label: 'End Time', alignRight: true },
  { id: '', label: 'Checkout Guests', alignRight: true },
  { id: '', label: 'Checkin Guests', alignRight: true },
  { id: '', label: 'Cleaning Item', alignRight: true },
  { id: '', label: 'Money Found (Cleaner)', alignRight: true },
  { id: '', label: 'Money Found (Guest)', alignRight: true },
  { id: '', label: 'Extra', alignRight: true },
  { id: '', label: 'Expenses', alignRight: false },
  { id: '', label: 'Cleaning Cost', alignRight: true },
  { id: '', label: 'Bedsheet Cost', alignRight: true },
  { id: '', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const formatGuestMoneyFound = (row) => {
  const amount = String(row?.guestMoneyFoundAmount || '').trim();
  if (amount) return /eur|€/i.test(amount) ? amount : `${amount} EUR`;
  return row?.guestMoneyFound ? 'Yes, no amount' : '-';
};

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function CleaningReport() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [totalCount, setTotalCount] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const initialBnbFilter = new URLSearchParams(location.search).get('bnb') || '';
  const [open, setOpen] = useState(null);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [clickedRowData, setClickedRowData] = useState(null);
  const [cleaningItem, setCleaningItem] = useState('');
  const [cleaners, setCleaners] = useState([]);
  const [users, setUsers] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [originalUsers, setOriginalUsers] = useState([]);
  const [endDate, setEndDate] = useState(null);
  const [bnbs, setBnbs] = useState([]);
  const [bnbValue, setBnBValue] = useState(initialBnbFilter);
  const [count, setCount] = useState({});
  const [averageCal, setAverageCal] = useState(0);
  const [quickFilter, setQuickFilter] = useState('');
  const [filters, setFilters] = useState({
    bnb: initialBnbFilter,
    cleanerName: '',
    startDate: '',
    endDate: '',
    quickFilter: '',
  });
  console.log(averageCal);
  const handleStartDateChange = (newValue) => {
    setStartDate(newValue); // Update state when date is selected
  };
  useEffect(() => {
    const hideLicenseKeyMessage = () => {
      // Select all divs
      const messages = document.querySelectorAll('button');
      // console.log(messages);
      messages.forEach((message) => {
        if (message.classList.contains('yarl__button')) {
          message.style.margin = '60px'; // Set margin to 40px
        }
      });
    };

    // Run the function after the component mounts
    hideLicenseKeyMessage();

    // Optional: Use MutationObserver to detect changes if the message might reappear
    const observer = new MutationObserver(hideLicenseKeyMessage);
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup observer on component unmount
    return () => {
      observer.disconnect();
    };
  }, []);
  const handleEndDateChange = (newValue) => {
    setEndDate(newValue); // Update state when date is selected
  };
  async function fetchData(currentPage = page, currentRowsPerPage = rowsPerPage, filters = {}) {
    const data = {
      page: currentPage + 1,
      limit: currentRowsPerPage,
      ...filters,
    };
    try {
      setLoading(true);
      const usersResponse = await getAllCleaningReport(data);
      const filteredUsers = usersResponse?.data?.data;
      setUsers(filteredUsers);
      setOriginalUsers(filteredUsers);
      const cleanerResponse = await getAllCleaner();
      setCleaners(cleanerResponse?.data?.data);
      const checkINCount = await checkInCheckOutCount();
      console.log('check in count', checkINCount?.data);
      const settingResponse = await getCleanerSetting();
      setAverageCal(settingResponse?.data?.data?.ignoreAverageCalValue);
      setCount(checkINCount?.data);
      setLoading(false);
      setTotalCount(usersResponse?.data?.meta?.total || 0);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  async function fetchBNB() {
    try {
      const usersResponse = await getBnbList();
      setBnbs(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData(page, rowsPerPage, filters);
    fetchBNB();
  }, [page, rowsPerPage]);

  const handleUpdate = async (id) => {
    try {
      const headers = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await updateMaintance(id, headers);

      fetchData();
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'An error occur',
      });
    }
  };

  const [loading, setLoading] = useState(false);
  const handleDelete = async (event, row) => {
    try {
      const allImages = [...row.cleaningImages, ...row.moneyFoundImages, ...row.expenseImages, ...row.extraImages];

      console.log('All images:', allImages); // Log the collected images
      const confirmed = await Swal.fire({
        icon: 'warning',
        title: 'Are you sure you want to delete this Cleaning Report?',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
      });
      if (confirmed.isConfirmed) {
        const headers = {
          headers: {
            'Content-Type': 'application/json',
          },
        };
        await Promise.all(
          allImages.map(async (image) => {
            const data = {
              filename: image,
            };
            await deleteUploads(data, headers); // Delete each image
          })
        );

        const header = {
          headers: {
            'Content-Type': 'application/json',
          },
        };

        const response = await deleteCleanerReport(row?._id, headers);
        Swal.fire({
          icon: 'success',
          title: 'Cleaning Report deleted successfully',
        });
        fetchData();
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'An error occur while deleting Cleaning Report',
      });
    }
  };
  const handleOpenMenu = (event, row) => {
    setOpen(event.currentTarget);
    setClickedRowData(row);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  // const encodedData = encodeURIComponent(JSON.stringify(clickedRow));

  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openLightbox = (images, index) => {
    setCurrentImages(images.map((image) => ({ src: `${appConfig.FILE_URL}${image}` })));
    setCurrentIndex(index);
    setIsOpen(true);
  };

  // const handleFilter = () => {
  //   if (!cleaningItem && !startDate && !endDate && !bnbValue) {
  //     fetchData();
  //     return;
  //   }

  //   // Adjust the selected dates to include the entire day
  //   const start = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : null;
  //   const end = endDate ? new Date(endDate).setHours(23, 59, 59, 999) : null;

  //   // Filter users based on cleaningItem and createdAt date range
  //   const filtered = originalUsers?.filter((user) => {
  //     const isCleanerNameMatch = cleaningItem ? user.cleanerName === cleaningItem : true;
  //     const isBnBMatch = bnbValue ? user.bnb === bnbValue : true;

  //     // Check if the user's createdAt is within the selected date range
  //     const isDateInRange = () => {
  //       if (!startDate && !endDate) return true;
  //       const createdAt = new Date(user.createdAt).getTime();
  //       if (startDate && endDate) return createdAt >= start && createdAt <= end;
  //       if (startDate) return createdAt >= start;
  //       if (endDate) return createdAt <= end;
  //       return false;
  //     };

  //     return isCleanerNameMatch && isDateInRange() && isBnBMatch;
  //   });

  //   setUsers(filtered);
  //   console.log({ cleaningItem, start: new Date(start).toISOString(), end: new Date(end).toISOString() });
  // };

  const buildReportFilters = (overrideQuickFilter = quickFilter) => {
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    if (start) start.setHours(0, 0, 0, 0);
    if (end) end.setHours(23, 59, 59, 999);

    return {
      bnb: bnbValue || '',
      cleanerName: cleaningItem || '',
      startDate: start ? start.toISOString() : '',
      endDate: end ? end.toISOString() : '',
      quickFilter: overrideQuickFilter || '',
    };
  };

  const applyReportFilters = (nextQuickFilter = quickFilter) => {
    const filteredData = buildReportFilters(nextQuickFilter);
    setFilters(filteredData);
    setPage(0);
    fetchData(0, rowsPerPage, filteredData);
  };

  const handleFilter = () => {
    applyReportFilters();
  };

  const handleQuickFilter = (nextQuickFilter) => {
    const activeQuickFilter = quickFilter === nextQuickFilter ? '' : nextQuickFilter;
    setQuickFilter(activeQuickFilter);
    applyReportFilters(activeQuickFilter);
  };

  const handleReset = () => {
    setCleaningItem('');
    setBnBValue('');
    setStartDate(null);
    setEndDate(null);
    setQuickFilter('');
    setFilters({});
    setPage(0);
    fetchData(0, rowsPerPage, {});
  };

  const [openEditForm, setOpenEditForm] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const [money, setMoney] = useState(0);
  const [expense, setExpense] = useState(0);
  const [cleaningCost, setCleaningCost] = useState(0);
  const [bedsheetCost, setBedsheetCost] = useState(0);

  const handleClickOpen = (data) => {
    setSelectedReport(data);

    // Pre-fill with selectedReport data if available
    setMoney(data?.money || 0);
    setExpense(data?.expense || 0);
    setCleaningCost(data?.cleaningCost || 0);
    setBedsheetCost(data?.bedsheetCost || 0);

    setOpenEditForm(true);
  };

  const handleClose = () => {
    setOpenEditForm(false);
    setSelectedReport(null);
    setMoney('');
    setExpense('');
    setCleaningCost('');
    setBedsheetCost('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const updatedReport = {
      money,
      expense,
      cleaningCost,
      bedsheetCost,
    };

    const headers = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const response = await updateCleaningReport(selectedReport?._id, updatedReport, headers);

    setUsers((prevUsers) =>
      prevUsers.map((user) => (user._id === selectedReport?._id ? { ...user, ...updatedReport } : user))
    );

    Swal.fire({
      icon: 'success',
      title: 'Cleaning Report updated successfully',
    });

    console.log('Updated Report:', updatedReport);
    // You can now send `updatedReport` to your API or update your state

    handleClose();
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - totalCount) : 0;

  const filteredUsers = applySortFilter(users, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> Cleaning Report </title>
      </Helmet>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={3} md={2}>
          <AppWidgetSummary
            title="Total Money Found (Cleaner)"
            total={filteredUsers?.reduce((acc, curr) => acc + curr.money, 0)}
            color="info"
            icon={'mdi:cash-multiple'}
            euro="€"
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <AppWidgetSummary
            title="Total Expenses"
            total={filteredUsers?.reduce((acc, curr) => acc + curr.expense, 0)}
            color="info"
            icon={'mdi:cash-multiple'}
            euro="€"
          />
        </Grid>
        {/* <Grid item xs={12} sm={3} md={1.5}>
          <AppWidgetSummary title="Total Check In" total={count?.checkInCount} color="info" icon={'mdi:cash-multiple'} />
        </Grid> */}
        {/* <Grid item xs={12} sm={3} md={1.5}>
          <AppWidgetSummary title="Total Check Out" total={count?.checkOutCount} color="info" icon={'mdi:cash-multiple'} />
        </Grid> */}
        <Grid item xs={12} sm={3} md={2}>
          <AppWidgetSummary
            title="Total Cleaning Cost"
            total={filteredUsers?.reduce((acc, curr) => acc + curr.cleaningCost, 0)}
            color="info"
            icon={'mdi:cash-multiple'}
            euro="€"
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <AppWidgetSummary
            title="Average Cleaning Cost"
            total={(() => {
              const validUsers = filteredUsers?.filter((user) => user.cleaningCost > averageCal) || [];
              const totalCost = validUsers.reduce((acc, curr) => acc + curr.cleaningCost, 0);
              const average = validUsers.length > 0 ? totalCost / validUsers.length : 0;
              return average.toFixed(2); // optional: format to 2 decimal places
            })()}
            color="info"
            icon={'mdi:cash-multiple'}
            euro="€"
          />
        </Grid>

        <Grid item xs={12} sm={3} md={2}>
          <AppWidgetSummary
            title="Total Bedsheet Cost"
            total={filteredUsers?.reduce((acc, curr) => acc + curr.bedsheetCost, 0)}
            color="info"
            icon={'mdi:cash-multiple'}
            euro="€"
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <AppWidgetSummary
            title="Average Bedsheet Cost"
            total={(() => {
              const validUsers = filteredUsers?.filter((user) => user.bedsheetCost > averageCal) || [];
              const totalCost = validUsers.reduce((acc, curr) => acc + curr.bedsheetCost, 0);
              const average = validUsers.length > 0 ? totalCost / validUsers.length : 0;
              return average.toFixed(2); // optional: format to 2 decimal places
            })()}
            color="info"
            icon={'mdi:cash-multiple'}
            euro="€"
          />
        </Grid>
      </Grid>
      <CSVLink
        data={filteredUsers.map((item) => ({
          BNB: item.bnb,
          CleanerName: item.cleanerName,
          GuestName: item.guestName,
          Date: new Date(item.createdAt).toLocaleDateString(),
          StartTime: new Date(item.startTime).toLocaleTimeString(),
          EndTime: new Date(item.endTime).toLocaleTimeString(),
          CheckoutGuests: item.noOfCheckOutGuests,
          CheckinGuests: item.noOfCheckInGuests,
          MoneyFoundCleaner: item.money,
          MoneyFoundGuest: formatGuestMoneyFound(item),
          MoneyFoundMismatch: item.moneyMismatch ? 'YES' : 'NO',
          Extra: item.extra,
          Expenses: item.expense,
          CleaningCost: item.cleaningCost,
          BedsheetCost: item.bedsheetCost,
        }))}
        filename={`Cleaning Report.csv`}
        className="flex items-center self-end w-40 mt-2 border border-gray-200 rounded-md px-4 py-2 text-white hover:bg-[#142A47] bg-[#1E3A5F]"
      >
        <FileText size={16} /> &nbsp; Export CSV
      </CSVLink>
      <Card sx={{ padding: 3, marginTop: 3 }}>
        <Stack mb={3} direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4">Cleaning Report{' '}<InfoTooltip width={20} title="A log of every cleaning submitted by cleaners, with photos, money found, expenses and cleaning/bedsheet costs per booking. Records are created when a cleaner completes a job in their app, and the summary cards above total money, expenses and average costs. Filter by date range, cleaner or property, use the quick filters for duplicates, high costs or money mismatches, edit a row's amounts, or Export CSV." /></Typography>
          <Stack direction="row" alignItems="center" gap={2}>

            <Button
              sx={{
                boxShadow: 'none',
                backgroundColor: quickFilter === 'duplicates' ? '#1f4e79' : '#eef3f8',
                color: quickFilter === 'duplicates' ? '#fff' : '#1f4e79',
                '&:hover': {
                  backgroundColor: quickFilter === 'duplicates' ? '#1f4e79' : '#dde8f3',
                  boxShadow: 'none',
                },
              }}
              variant="contained"
              onClick={() => handleQuickFilter('duplicates')}
            >
              Duplicati
            </Button>

            <Button
              sx={{
                boxShadow: 'none',
                backgroundColor: quickFilter === 'highCosts' ? '#9f2f00' : '#fff2e8',
                color: quickFilter === 'highCosts' ? '#fff' : '#9f2f00',
                '&:hover': {
                  backgroundColor: quickFilter === 'highCosts' ? '#9f2f00' : '#ffe0cc',
                  boxShadow: 'none',
                },
              }}
              variant="contained"
              onClick={() => handleQuickFilter('highCosts')}
            >
              Costi &gt; 100 EUR
            </Button>

            <Button
              sx={{
                boxShadow: 'none',
                backgroundColor: quickFilter === 'moneyMismatch' ? '#8a1c2c' : '#fff0f3',
                color: quickFilter === 'moneyMismatch' ? '#fff' : '#8a1c2c',
                '&:hover': {
                  backgroundColor: quickFilter === 'moneyMismatch' ? '#8a1c2c' : '#ffd9e0',
                  boxShadow: 'none',
                },
              }}
              variant="contained"
              onClick={() => handleQuickFilter('moneyMismatch')}
            >
              Money mismatch
            </Button>

            <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
              <DatePicker
                slotProps={{ textField: { size: 'small' } }}
                label="Start Date"
                value={startDate}
                onChange={handleStartDateChange} // Capture date and update state
                renderInput={(params) => <TextField size="small" {...params} />} // Optional: If you want to display a TextField
              />
            </Stack>

            <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
              <DatePicker
                slotProps={{ textField: { size: 'small' } }}
                label="End Date"
                value={endDate}
                onChange={handleEndDateChange} // Capture date and update state
                renderInput={(params) => <TextField size="small" {...params} />} // Optional: If you want to display a TextField
              />
            </Stack>

            <Stack>
              <FormControl size="small" sx={{ width: 270 }}>
                {/* <FormLabel sx={{ mb: 1 }}>Cleaning Item</FormLabel> */}
                <InputLabel id="demo-simple-select-label">Cleaner Name</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={cleaningItem}
                  label="Cleaner Name"
                  onChange={(e) => setCleaningItem(e.target.value)}
                >
                  {cleaners?.map((user) => (
                    <MenuItem key={user._id} value={user.name}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>

            <Stack>
              <FormControl size="small" sx={{ width: 270 }}>
                {/* <FormLabel sx={{ mb: 1 }}>Cleaning Item</FormLabel> */}
                <InputLabel id="demo-simple-select-label">BNB</InputLabel>
                <Select
                  labelId="demo-simple-select"
                  id="demo-simple"
                  value={bnbValue}
                  label="BNB"
                  onChange={(e) => setBnBValue(e.target.value)}
                >
                  {bnbs?.map((item) => (
                    <MenuItem key={item._id} value={item.BnBShortName}>
                      {item.BnBShortName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>

            <Button
              sx={{
                boxShadow: 'none',
                backgroundColor: '#1E3A5F',
                '&:hover': {
                  backgroundColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              variant="contained"
              endIcon={<Iconify icon="eva:funnel-outline" />}
              onClick={handleFilter}
            >
              Filter
            </Button>

            <Button
              sx={{
                boxShadow: 'none',
                backgroundColor: '#c1121f',
                '&:hover': {
                  backgroundColor: '#c1121f',
                  boxShadow: 'none',
                },
              }}
              variant="contained"
              endIcon={<Iconify icon="eva:refresh-outline" />}
              onClick={handleReset}
            >
              Reset
            </Button>
          </Stack>
        </Stack>

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <SolutionListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={users.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    const {
                      _id,
                      bnb,
                      cleanerName,
                      guestName,
                      cleaningImages,
                      moneyFoundImages,
                      expenseImages,
                      extraImages,
                      money,
                      guestMoneyFound,
                      guestMoneyFoundAmount,
                      moneyMismatch,
                      expense,
                      extra,
                      cleaningCost,
                      bedsheetCost,
                      createdAt,
                      startTime,
                      endTime,
                      noOfCheckOutGuests,
                      noOfCheckInGuests,
                    } = row;
                    const isHighlighted = expense > 100 || cleaningCost > 100 || bedsheetCost > 100;
                    const guestMoneyLabel = formatGuestMoneyFound({ guestMoneyFound, guestMoneyFoundAmount });
                    return (
                      <TableRow
                        sx={{
                          backgroundColor: isHighlighted ? '#FFEBEB' : 'inherit', // Light red background for highlighted rows
                        }}
                        hover
                        key={_id}
                      >
                        <TableCell align="left">{bnb}</TableCell>
                        <TableCell align="left">{cleanerName}</TableCell>
                        <TableCell align="left">{guestName}</TableCell>
                        <TableCell align="left">{new Date(createdAt).toLocaleDateString()}</TableCell>
                        <TableCell align="left">{new Date(startTime).toLocaleTimeString()}</TableCell>
                        <TableCell align="left">{new Date(endTime).toLocaleTimeString()}</TableCell>
                        <TableCell align="left">{noOfCheckOutGuests}</TableCell>
                        <TableCell align="left">{noOfCheckInGuests}</TableCell>
                        <TableCell align="left">
                          <div style={{ display: 'flex' }}>
                            {/* {cleaningImages?.map((image, index) => ( */}
                            <Avatar
                              // key={index}
                              alt={`Cleaning Image ${1}`}
                              src={`${appConfig.FILE_URL}${cleaningImages[0]}`}
                              sx={{ width: 40, height: 40, cursor: 'pointer' }}
                              onClick={() => openLightbox(cleaningImages)}
                            />
                            {/* ))} */}
                          </div>
                        </TableCell>

                        <TableCell sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} align="left">
                          <>{money} EUR</>
                          <div style={{ display: 'flex' }}>
                            {moneyFoundImages?.map((image, index) => (
                              <Avatar
                                key={index} // Use index as a key; prefer a unique identifier if available
                                alt={`Image ${index + 1}`}
                                src={`${appConfig.FILE_URL}${image}`} // Ensure the URL is constructed
                                sx={{ width: 40, height: 40 }} // Customize size as needed
                                onClick={() => openLightbox(moneyFoundImages, index)}
                              />
                            ))}
                          </div>
                        </TableCell>

                        <TableCell
                          align="left"
                          sx={{
                            color: moneyMismatch ? '#b42318' : 'inherit',
                            fontWeight: moneyMismatch ? 700 : 400,
                            backgroundColor: moneyMismatch ? '#fff1f0' : 'inherit',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {guestMoneyLabel}
                          {moneyMismatch ? ' - mismatch' : ''}
                        </TableCell>

                        <TableCell align="left">
                          <>{extra}</>
                          <div style={{ display: 'flex' }}>
                            {extraImages?.map((image, index) => (
                              <Avatar
                                key={index} // Use index as a key; prefer a unique identifier if available
                                alt={`Image ${index + 1}`}
                                src={`${appConfig.FILE_URL}${image}`} // Ensure the URL is constructed correctly
                                sx={{ width: 40, height: 40 }} // Customize size as needed
                                onClick={() => openLightbox(extraImages, index)}
                              />
                            ))}
                          </div>
                        </TableCell>
                        <TableCell
                          sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                          align="right"
                        >
                          <>{expense} €</>
                          <div style={{ display: 'flex' }}>
                            {expenseImages?.map((image, index) => (
                              <Avatar
                                key={index} // Use index as a key; prefer a unique identifier if available
                                alt={`Image ${index + 1}`}
                                src={`${appConfig.FILE_URL}${image}`} // Ensure the URL is constructed correctly
                                sx={{ width: 40, height: 40 }} // Customize size as needed
                                onClick={() => openLightbox(expenseImages, index)}
                              />
                            ))}
                          </div>
                        </TableCell>
                        <TableCell align="left">{cleaningCost} €</TableCell>

                        <TableCell align="left">{bedsheetCost} €</TableCell>
                        <TableCell align="center">
                          <Stack
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: 1,
                            }}
                          >
                            <Button
                              // onClick={() =>
                              //   navigate('/cleaningReport/update_cleaner_report', { state: { userData: row } })
                              // }

                              onClick={(event) => handleClickOpen(row)}
                              sx={{
                                boxShadow: 'none',
                                backgroundColor: '#B5FFD8',
                                color: '#009245',
                                '&:hover': {
                                  backgroundColor: '#B5FFD8',
                                  boxShadow: 'none',
                                },
                              }}
                              size="small"
                              variant="contained"
                              startIcon={<MdOutlineEdit />}
                            >
                              Edit
                            </Button>
                            <Button
                              onClick={(event) => handleDelete(event, row)}
                              sx={{
                                boxShadow: 'none',
                                backgroundColor: '#FFC6C6',
                                color: '#DC2626',
                                '&:hover': {
                                  backgroundColor: '#FFC6C6',
                                  boxShadow: 'none',
                                },
                              }}
                              size="small"
                              variant="contained"
                              startIcon={<CiTrash />}
                            >
                              Delete
                            </Button>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={7} />
                  </TableRow>
                )}
                {loading && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={7}>
                      <CircularProgress size="20px" />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >
                        <Typography variant="h6" paragraph>
                          Not found
                        </Typography>

                        <Typography variant="body2">
                          No results found for &nbsp;
                          <strong>&quot;{filterName}&quot;</strong>.
                          <br /> Try checking for typos or using complete words.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[100, 200, 300]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        {/*     
        <Link
          
          style={{ textDecoration: 'none' }}
          // to={`/dashboard/user-detail/${encodeURIComponent(JSON.stringify(clickedRow))}`}
          to={`/dashboard/user-detail?data=${encodedData}`}
        > */}
        <MenuItem
          onClick={() => navigate('/contractor/contractor-detail', { state: { clickedRowData } })}
          sx={{ color: 'success.main' }}
        >
          <Iconify icon={'eva:image-outline'} sx={{ mr: 2 }} />
          Detail
        </MenuItem>
        {/* </Link> */}
        <MenuItem>
          <Iconify icon={'eva:edit-outline'} sx={{ mr: 2 }} />
          Block
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>

      {isOpen && (
        <Lightbox
          slides={currentImages}
          open={isOpen}
          index={currentIndex}
          close={() => setIsOpen(false)}
          on={{
            clickNext: () => setCurrentIndex((currentIndex + 1) % currentImages.length),
            clickPrev: () => setCurrentIndex(currentIndex === 0 ? currentImages.length - 1 : currentIndex - 1),
          }}
        />
      )}

      <Dialog open={openEditForm} onClose={handleClose}>
        <DialogTitle>Edit Report</DialogTitle>
        <DialogContent sx={{ paddingBottom: 0 }}>
          <DialogContentText sx={{ mb: 2 }}>Please update the report fields below:</DialogContentText>
          <form onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <Stack>
                <FormLabel sx={{ mb: 1 }}>Money Found <InfoTooltip title="Cash the cleaner found and reported during this cleaning, in euros." /></FormLabel>
                <TextField type="number" label="Enter" value={money} onChange={(e) => setMoney(e.target.value)} />
              </Stack>

              <Stack>
                <FormLabel sx={{ mb: 1 }}>Expense <InfoTooltip title="Out-of-pocket amount the cleaner spent during this cleaning, in euros." /></FormLabel>
                <TextField type="number" label="Enter" value={expense} onChange={(e) => setExpense(e.target.value)} />
              </Stack>

              <Stack>
                <FormLabel sx={{ mb: 1 }}>Cleaning Cost <InfoTooltip title="Amount charged for this cleaning, in euros; feeds the report totals and averages." /></FormLabel>
                <TextField
                  type="number"
                  label="Enter"
                  value={cleaningCost}
                  onChange={(e) => setCleaningCost(e.target.value)}
                />
              </Stack>

              <Stack>
                <FormLabel sx={{ mb: 1 }}>Bedsheet Cost <InfoTooltip title="Charge for the bed-linen change on this cleaning, in euros." /></FormLabel>
                <TextField
                  type="number"
                  label="Enter"
                  value={bedsheetCost}
                  onChange={(e) => setBedsheetCost(e.target.value)}
                />
              </Stack>
            </Stack>

            <DialogActions sx={{ mt: 3 }}>
              <Button onClick={handleClose}>Cancel</Button>
              <Button type="submit" variant="contained">
                Update
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
